import Disposable from "@/game/libs/engine/util/disposable";

export default class Disposer implements Disposable {
  public dispose: () => void;

  constructor(dispose: () => void) {
    this.dispose = dispose;
  }

  reset() {
    this.dispose = null as any;
  }
}
